import { TimelineStore } from './TimelineStore';

let _intervalId: ReturnType<typeof setInterval> | null = null;

function _clearInterval(): void {
  if (_intervalId !== null) {
    clearInterval(_intervalId);
    _intervalId = null;
  }
}

function _reschedule(): void {
  _clearInterval();
  const { speed } = TimelineStore.getState();
  _intervalId = setInterval(
    () => {
      const { currentDecade, maxDecade } = TimelineStore.getState();
      if (currentDecade >= maxDecade) {
        stopPlay();
        return;
      }
      const next = currentDecade + 10;
      TimelineStore.setState({ currentDecade: next });
      if (next >= maxDecade) {
        stopPlay();
      }
    },
    Math.round(1000 / speed),
  );
}

export function startPlay(): void {
  if (TimelineStore.getState().playing) {
    return;
  }
  // If already at the end, restart from minDecade
  const { currentDecade, maxDecade, minDecade } = TimelineStore.getState();
  if (currentDecade >= maxDecade) {
    TimelineStore.setState({ currentDecade: minDecade, playing: true });
  } else {
    TimelineStore.setState({ playing: true });
  }
  _reschedule();
}

export function stopPlay(): void {
  _clearInterval();
  TimelineStore.setState({ playing: false });
}

export function togglePlay(): void {
  if (TimelineStore.getState().playing) {
    stopPlay();
  } else {
    startPlay();
  }
}

export function stepForward(): void {
  stopPlay();
  const { currentDecade, maxDecade } = TimelineStore.getState();
  TimelineStore.setState({ currentDecade: Math.min(currentDecade + 10, maxDecade) });
}

export function stepBackward(): void {
  stopPlay();
  const { currentDecade, minDecade } = TimelineStore.getState();
  TimelineStore.setState({ currentDecade: Math.max(currentDecade - 10, minDecade) });
}

export function setSpeed(speed: 1 | 2 | 5): void {
  TimelineStore.setState({ speed });
  if (TimelineStore.getState().playing) {
    _reschedule();
  }
}
